import { render, staticRenderFns } from "./MoveManager.vue?vue&type=template&id=4fa3505c&scoped=true&"
import script from "./MoveManager.vue?vue&type=script&lang=js&"
export * from "./MoveManager.vue?vue&type=script&lang=js&"
import style0 from "./MoveManager.vue?vue&type=style&index=0&id=4fa3505c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa3505c",
  null
  
)

export default component.exports